/*
 * View for the topic publish modal
 */

define(["marionette", "./template/topicDisableModalTemplate.html"], function (
  Marionette,
  TopicDisableModalTemplate,
) {
  var TopicDisableModalView = {};

  TopicDisableModalView.topicDisableModalLayout = Marionette.Layout.extend({
    template: TopicDisableModalTemplate,
    regions: {
      responseList: "#disableResponseList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#responseError").hide();
    },
    showError: function () {
      this.$el.find("#responseError").attr("data-i18n", "topic.disable.error").i18n().show();
    },
  });

  return TopicDisableModalView;
});
